export default __webpack_public_path__ + "static/media/2.185ec2c6.jpg";